import { createAction, props } from '@ngrx/store';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../store/entity-state/entity-actions-factory';
import { CreateEnquiryRequestDto, EnquiryDto } from '@careapp-group/ng-sdk';
import { EnquiriesFilterType } from './enquiries.reducer';

export class EnquiriesActions extends CaEntityActionsFactory<
  EnquiryDto,
  CreateEnquiryRequestDto,
  EnquiryDto,
  EnquiriesFilterType
> {
  constructor() {
    super('enquiries');
  }

  updateUnreadEnquiryCount = createAction(
    `[${this.type}][Update] unread count`,
    props<{ count: number }>(),
  );

  requestCompleteEnquiry = createAction(
    '[Enquiries][Request] mark complete',
    props<{ enquiryId: string }>(),
  );

  successCompleteEnquiry = createAction(
    '[Enquiries][Success] mark complete',
    props<{ enquiryId: string }>(),
  );

  failCompleteEnquiry = createAction(
    '[Enquiries][Fail] mark complete',
    props<{ enquiryId: string; error?: any }>(),
  );

  requestUpdateEnquiryAssignee = createAction(
    '[Enquiries][Request] update assignee',
    props<{ channelId: string; assigneeId: string }>(),
  );

  successUpdateEnquiryAssignee = createAction(
    '[Enquiries][Success] update assignee',
    props<{ channelId: string; updatedEnquiry: EnquiryDto }>(),
  );

  failUpdateEnquiryAssignee = createAction(
    '[Enquiries][Fail] update assignee',
    props<{ error?: any }>(),
  );

  requestCreateEnquiry = createAction('[Enquiries][Request] create enquiry');

  successCreateEnquiry = createAction(
    '[Enquiries][Success] create enquiry',
    props<{ enquiry: EnquiryDto }>(),
  );

  failCreateEnquiry = createAction('[Enquiries][Fail] create enquiry', props<{ error?: any }>());

  requestRateEnquiry = createAction(
    '[Enquiries][Request] rate enquiry',
    props<{ enquiryId: string; rating: number }>(),
  );

  successRateEnquiry = createAction(
    '[Enquiries][Success] rate enquiry',
    props<{ updatedEnquiry: EnquiryDto }>(),
  );

  failRateEnquiry = createAction('[Enquiries][Fail] rate enquiry', props<{ error?: any }>());

  requestSetCategories = createAction(
    '[Enquiries][Request] set categories',
    props<{ enquiryId: string; categories: string[] }>(),
  );

  successSetCategories = createAction(
    '[Enquiries][Success] set categories',
    props<{ updatedEnquiry: EnquiryDto }>(),
  );

  failSetCategories = createAction('[Enquiries][Fail] set categories', props<{ error?: any }>());

  setActiveEnquiryChannel = createAction(
    '[Enquiries] Set Active Channel',
    props<{ cid?: string }>(),
  );
}

export const Enquiries = new EnquiriesActions();
